/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type ScenarioDisplayType = (typeof ScenarioDisplayType)[keyof typeof ScenarioDisplayType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScenarioDisplayType = {
  POPUP: 'POPUP',
  SLIDER: 'SLIDER',
  TILE: 'TILE',
  BOX: 'BOX',
  WIDE: 'WIDE',
  WIDE_SINGLE: 'WIDE_SINGLE',
} as const
